var map = {
	"./Loading-Icon.gif": 1194,
	"./app-awareness-phone.png": 401,
	"./app-modal-android@2x.png": 678,
	"./app-modal-iphone@2x.png": 679,
	"./app-promo-banner-background.png": 1195,
	"./box-prices/2-portions.png": 680,
	"./box-prices/2-portions.webp": 681,
	"./box-prices/4-portions.png": 682,
	"./box-prices/4-portions.webp": 683,
	"./box-prices/best-value.png": 684,
	"./box-prices/box-prices-hero.jpg": 778,
	"./box-prices/couples-box.jpg": 1196,
	"./box-prices/family-box.jpg": 1197,
	"./box-prices/four-person-box.jpg": 518,
	"./box-prices/most-popular.png": 685,
	"./box-prices/two-person-box.jpg": 517,
	"./discount-modal-header.jpg": 522,
	"./earn-reward-background.jpg": 1198,
	"./five-recipes/five-recipes.png": 686,
	"./gousto-boxes.jpg": 687,
	"./gousto-welcome-journey-rollover.jpg": 1199,
	"./hungry-for-savings.png": 1200,
	"./menu/FebYouary_desktop.jpg": 1201,
	"./menu/FebYouary_mobile.jpg": 1202,
	"./menu/FebYouary_tablet.jpg": 1203,
	"./menu/default_desktop_no_click.png": 1204,
	"./menu/default_mobile_no_click.png": 1205,
	"./menu/default_tablet_no_click.png": 1206,
	"./menu/spottyTileBorder.png": 688,
	"./my-gousto-pricing-modal.svg": 1207,
	"./pause-osr-modal-bg.jpg": 1208,
	"./product-placeholder.png": 523,
	"./recipe-placeholder.png": 339,
	"./red-rice-pattern.png": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661;